export default __webpack_public_path__ + "static/media/labra.fd0f53a1.svg";